import { fetchProjectTaglinks } from '../../project-actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, Link } from 'react-router';
import { useProject } from '../../project-hooks/useProject';
import { BodyText } from '../../../components/typography/Heading';

export const ProjectTagInfo = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const project = useProject();

    useEffect(() => {
        ProjectTagInfo.fetchData(dispatch, params);
    }, [dispatch]);

    if (!project?.tagLinks) {
        return null;
    }
    const links = project.tagLinks.map((link) => (
        <BodyText key={link.link}>
            Les mer om <Link to={link.link}>{link.text}</Link>.
        </BodyText>
    ));
    return links;
};
ProjectTagInfo.fetchData = async (dispatch, params) => {
    dispatch(fetchProjectTaglinks(params.projectId));
};
